import "./Contributors.css";

function Contributors() {
  return (
    <>
      <div className="head">
        <p id="heading">Chief Team</p>
      </div>
      <div className="chief">
        <div id="chief_1">
          <div className="photo">
            <img
              src="http://cdn.onlinewebfonts.com/svg/img_550782.png"
              alt="not available"
            />
          </div>
          <div id="chief_2">
            <p>Person Name</p>
            <br />
            <a href="#" target="_blank" rel="noopener noreferrer">
              <svg
                width="50"
                height="51"
                viewbox="0 0 51 51"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip_0_5_39)">
                  <path
                    d="M47.1929 3.78857H4.13599C2.16306 3.78857 0.560059 5.21082 0.560059 6.95675V44.5629C0.560059 46.3088 2.16306 47.7311 4.13599 47.7311H47.1929C49.1658 47.7311 50.7801 46.3088 50.7801 44.5629V6.95675C50.7801 5.21082 49.1658 3.78857 47.1929 3.78857ZM15.7382 41.4536H8.29484V20.4828H15.7494V41.4536H15.7382ZM12.0165 17.6187C9.6288 17.6187 7.70072 15.9218 7.70072 13.8424C7.70072 11.763 9.6288 10.0661 12.0165 10.0661C14.393 10.0661 16.3323 11.763 16.3323 13.8424C16.3323 15.9316 14.4042 17.6187 12.0165 17.6187ZM43.6394 41.4536H36.1961V31.2526C36.1961 28.8201 36.14 25.6912 32.3287 25.6912C28.4501 25.6912 27.856 28.3395 27.856 31.0761V41.4536H20.4127V20.4828H27.5533V23.3469H27.6542C28.6519 21.6991 31.0844 19.9629 34.7052 19.9629C42.2382 19.9629 43.6394 24.3082 43.6394 29.9579V41.4536Z"
                    fill="black"
                  ></path>
                </g>
                <defs>
                  <clipPath id="clip_0_5_39">
                    <rect
                      width="50.22"
                      height="50.22"
                      fill="white"
                      transform="translate(0.560059 0.649902)"
                    ></rect>
                  </clipPath>
                </defs>
              </svg>
            </a>
          </div>
        </div>
        <div id="chief_1">
          <div className="photo">
            <img
              src="http://cdn.onlinewebfonts.com/svg/img_550782.png"
              alt="not available"
            />
          </div>
          <div id="chief_2">
            <p>Person Name</p>
            <br />
            <a href="#" target="_blank" rel="noopener noreferrer">
              <svg
                width="50"
                height="51"
                viewbox="0 0 51 51"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip_0_5_39)">
                  <path
                    d="M47.1929 3.78857H4.13599C2.16306 3.78857 0.560059 5.21082 0.560059 6.95675V44.5629C0.560059 46.3088 2.16306 47.7311 4.13599 47.7311H47.1929C49.1658 47.7311 50.7801 46.3088 50.7801 44.5629V6.95675C50.7801 5.21082 49.1658 3.78857 47.1929 3.78857ZM15.7382 41.4536H8.29484V20.4828H15.7494V41.4536H15.7382ZM12.0165 17.6187C9.6288 17.6187 7.70072 15.9218 7.70072 13.8424C7.70072 11.763 9.6288 10.0661 12.0165 10.0661C14.393 10.0661 16.3323 11.763 16.3323 13.8424C16.3323 15.9316 14.4042 17.6187 12.0165 17.6187ZM43.6394 41.4536H36.1961V31.2526C36.1961 28.8201 36.14 25.6912 32.3287 25.6912C28.4501 25.6912 27.856 28.3395 27.856 31.0761V41.4536H20.4127V20.4828H27.5533V23.3469H27.6542C28.6519 21.6991 31.0844 19.9629 34.7052 19.9629C42.2382 19.9629 43.6394 24.3082 43.6394 29.9579V41.4536Z"
                    fill="black"
                  ></path>
                </g>
                <defs>
                  <clipPath id="clip_0_5_39">
                    <rect
                      width="50.22"
                      height="50.22"
                      fill="white"
                      transform="translate(0.560059 0.649902)"
                    ></rect>
                  </clipPath>
                </defs>
              </svg>
            </a>
          </div>
        </div>
      </div>
      <div className="head">
        <p id="heading">Core and Management Team</p>
      </div>
      <div className="chief">
        <div id="C_M">
          <img
            src="http://cdn.onlinewebfonts.com/svg/img_550782.png"
            alt="not available"
          />
          <div className="C_M_E">
            <p>Person Name</p>
            <br />
            <a href="#" target="_blank" rel="noopener noreferrer">
              <svg
                width="50"
                height="51"
                viewbox="0 0 51 51"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip_0_5_39)">
                  <path
                    d="M47.1929 3.78857H4.13599C2.16306 3.78857 0.560059 5.21082 0.560059 6.95675V44.5629C0.560059 46.3088 2.16306 47.7311 4.13599 47.7311H47.1929C49.1658 47.7311 50.7801 46.3088 50.7801 44.5629V6.95675C50.7801 5.21082 49.1658 3.78857 47.1929 3.78857ZM15.7382 41.4536H8.29484V20.4828H15.7494V41.4536H15.7382ZM12.0165 17.6187C9.6288 17.6187 7.70072 15.9218 7.70072 13.8424C7.70072 11.763 9.6288 10.0661 12.0165 10.0661C14.393 10.0661 16.3323 11.763 16.3323 13.8424C16.3323 15.9316 14.4042 17.6187 12.0165 17.6187ZM43.6394 41.4536H36.1961V31.2526C36.1961 28.8201 36.14 25.6912 32.3287 25.6912C28.4501 25.6912 27.856 28.3395 27.856 31.0761V41.4536H20.4127V20.4828H27.5533V23.3469H27.6542C28.6519 21.6991 31.0844 19.9629 34.7052 19.9629C42.2382 19.9629 43.6394 24.3082 43.6394 29.9579V41.4536Z"
                    fill="black"
                  ></path>
                </g>
                <defs>
                  <clipPath id="clip_0_5_39">
                    <rect
                      width="50.22"
                      height="50.22"
                      fill="white"
                      transform="translate(0.560059 0.649902)"
                    ></rect>
                  </clipPath>
                </defs>
              </svg>
            </a>
          </div>
        </div>
        <div id="C_M">
          <img
            src="http://cdn.onlinewebfonts.com/svg/img_550782.png"
            alt="not available"
          />
          <div className="C_M_E">
            <p>Person Name</p>
            <br />
            <a href="#" target="_blank" rel="noopener noreferrer">
              <svg
                width="50"
                height="51"
                viewbox="0 0 51 51"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip_0_5_39)">
                  <path
                    d="M47.1929 3.78857H4.13599C2.16306 3.78857 0.560059 5.21082 0.560059 6.95675V44.5629C0.560059 46.3088 2.16306 47.7311 4.13599 47.7311H47.1929C49.1658 47.7311 50.7801 46.3088 50.7801 44.5629V6.95675C50.7801 5.21082 49.1658 3.78857 47.1929 3.78857ZM15.7382 41.4536H8.29484V20.4828H15.7494V41.4536H15.7382ZM12.0165 17.6187C9.6288 17.6187 7.70072 15.9218 7.70072 13.8424C7.70072 11.763 9.6288 10.0661 12.0165 10.0661C14.393 10.0661 16.3323 11.763 16.3323 13.8424C16.3323 15.9316 14.4042 17.6187 12.0165 17.6187ZM43.6394 41.4536H36.1961V31.2526C36.1961 28.8201 36.14 25.6912 32.3287 25.6912C28.4501 25.6912 27.856 28.3395 27.856 31.0761V41.4536H20.4127V20.4828H27.5533V23.3469H27.6542C28.6519 21.6991 31.0844 19.9629 34.7052 19.9629C42.2382 19.9629 43.6394 24.3082 43.6394 29.9579V41.4536Z"
                    fill="black"
                  ></path>
                </g>
                <defs>
                  <clipPath id="clip_0_5_39">
                    <rect
                      width="50.22"
                      height="50.22"
                      fill="white"
                      transform="translate(0.560059 0.649902)"
                    ></rect>
                  </clipPath>
                </defs>
              </svg>
            </a>
          </div>
        </div>
        <div id="C_M">
          <img
            src="http://cdn.onlinewebfonts.com/svg/img_550782.png"
            alt="not available"
          />
          <div className="C_M_E">
            <p>Person Name</p>
            <br />
            <a href="#" target="_blank" rel="noopener noreferrer">
              <svg
                width="50"
                height="51"
                viewbox="0 0 51 51"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip_0_5_39)">
                  <path
                    d="M47.1929 3.78857H4.13599C2.16306 3.78857 0.560059 5.21082 0.560059 6.95675V44.5629C0.560059 46.3088 2.16306 47.7311 4.13599 47.7311H47.1929C49.1658 47.7311 50.7801 46.3088 50.7801 44.5629V6.95675C50.7801 5.21082 49.1658 3.78857 47.1929 3.78857ZM15.7382 41.4536H8.29484V20.4828H15.7494V41.4536H15.7382ZM12.0165 17.6187C9.6288 17.6187 7.70072 15.9218 7.70072 13.8424C7.70072 11.763 9.6288 10.0661 12.0165 10.0661C14.393 10.0661 16.3323 11.763 16.3323 13.8424C16.3323 15.9316 14.4042 17.6187 12.0165 17.6187ZM43.6394 41.4536H36.1961V31.2526C36.1961 28.8201 36.14 25.6912 32.3287 25.6912C28.4501 25.6912 27.856 28.3395 27.856 31.0761V41.4536H20.4127V20.4828H27.5533V23.3469H27.6542C28.6519 21.6991 31.0844 19.9629 34.7052 19.9629C42.2382 19.9629 43.6394 24.3082 43.6394 29.9579V41.4536Z"
                    fill="black"
                  ></path>
                </g>
                <defs>
                  <clipPath id="clip_0_5_39">
                    <rect
                      width="50.22"
                      height="50.22"
                      fill="white"
                      transform="translate(0.560059 0.649902)"
                    ></rect>
                  </clipPath>
                </defs>
              </svg>
            </a>
          </div>
        </div>
        <div id="C_M">
          <img
            src="http://cdn.onlinewebfonts.com/svg/img_550782.png"
            alt="not available"
          />
          <div className="C_M_E">
            <p>Person Name</p>
            <br />
            <a href="#" target="_blank" rel="noopener noreferrer">
              <svg
                width="50"
                height="51"
                viewbox="0 0 51 51"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip_0_5_39)">
                  <path
                    d="M47.1929 3.78857H4.13599C2.16306 3.78857 0.560059 5.21082 0.560059 6.95675V44.5629C0.560059 46.3088 2.16306 47.7311 4.13599 47.7311H47.1929C49.1658 47.7311 50.7801 46.3088 50.7801 44.5629V6.95675C50.7801 5.21082 49.1658 3.78857 47.1929 3.78857ZM15.7382 41.4536H8.29484V20.4828H15.7494V41.4536H15.7382ZM12.0165 17.6187C9.6288 17.6187 7.70072 15.9218 7.70072 13.8424C7.70072 11.763 9.6288 10.0661 12.0165 10.0661C14.393 10.0661 16.3323 11.763 16.3323 13.8424C16.3323 15.9316 14.4042 17.6187 12.0165 17.6187ZM43.6394 41.4536H36.1961V31.2526C36.1961 28.8201 36.14 25.6912 32.3287 25.6912C28.4501 25.6912 27.856 28.3395 27.856 31.0761V41.4536H20.4127V20.4828H27.5533V23.3469H27.6542C28.6519 21.6991 31.0844 19.9629 34.7052 19.9629C42.2382 19.9629 43.6394 24.3082 43.6394 29.9579V41.4536Z"
                    fill="black"
                  ></path>
                </g>
                <defs>
                  <clipPath id="clip_0_5_39">
                    <rect
                      width="50.22"
                      height="50.22"
                      fill="white"
                      transform="translate(0.560059 0.649902)"
                    ></rect>
                  </clipPath>
                </defs>
              </svg>
            </a>
          </div>
        </div>
        <div id="C_M">
          <img
            src="http://cdn.onlinewebfonts.com/svg/img_550782.png"
            alt="not available"
          />
          <div className="C_M_E">
            <p>Person Name</p>
            <br />
            <a href="#" target="_blank" rel="noopener noreferrer">
              <svg
                width="50"
                height="51"
                viewbox="0 0 51 51"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip_0_5_39)">
                  <path
                    d="M47.1929 3.78857H4.13599C2.16306 3.78857 0.560059 5.21082 0.560059 6.95675V44.5629C0.560059 46.3088 2.16306 47.7311 4.13599 47.7311H47.1929C49.1658 47.7311 50.7801 46.3088 50.7801 44.5629V6.95675C50.7801 5.21082 49.1658 3.78857 47.1929 3.78857ZM15.7382 41.4536H8.29484V20.4828H15.7494V41.4536H15.7382ZM12.0165 17.6187C9.6288 17.6187 7.70072 15.9218 7.70072 13.8424C7.70072 11.763 9.6288 10.0661 12.0165 10.0661C14.393 10.0661 16.3323 11.763 16.3323 13.8424C16.3323 15.9316 14.4042 17.6187 12.0165 17.6187ZM43.6394 41.4536H36.1961V31.2526C36.1961 28.8201 36.14 25.6912 32.3287 25.6912C28.4501 25.6912 27.856 28.3395 27.856 31.0761V41.4536H20.4127V20.4828H27.5533V23.3469H27.6542C28.6519 21.6991 31.0844 19.9629 34.7052 19.9629C42.2382 19.9629 43.6394 24.3082 43.6394 29.9579V41.4536Z"
                    fill="black"
                  ></path>
                </g>
                <defs>
                  <clipPath id="clip_0_5_39">
                    <rect
                      width="50.22"
                      height="50.22"
                      fill="white"
                      transform="translate(0.560059 0.649902)"
                    ></rect>
                  </clipPath>
                </defs>
              </svg>
            </a>
          </div>
        </div>
      </div>
      <div className="head">
        <p id="heading">Contributors</p>
      </div>
      <div className="chief">
        <div id="C_M">
          <img
            src="http://cdn.onlinewebfonts.com/svg/img_550782.png"
            alt="not available"
          />
          <div className="C_M_E">
            <p>Person Name</p>
            <br />
            <a href="#" target="_blank" rel="noopener noreferrer">
              <svg
                width="50"
                height="51"
                viewbox="0 0 51 51"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip_0_5_39)">
                  <path
                    d="M47.1929 3.78857H4.13599C2.16306 3.78857 0.560059 5.21082 0.560059 6.95675V44.5629C0.560059 46.3088 2.16306 47.7311 4.13599 47.7311H47.1929C49.1658 47.7311 50.7801 46.3088 50.7801 44.5629V6.95675C50.7801 5.21082 49.1658 3.78857 47.1929 3.78857ZM15.7382 41.4536H8.29484V20.4828H15.7494V41.4536H15.7382ZM12.0165 17.6187C9.6288 17.6187 7.70072 15.9218 7.70072 13.8424C7.70072 11.763 9.6288 10.0661 12.0165 10.0661C14.393 10.0661 16.3323 11.763 16.3323 13.8424C16.3323 15.9316 14.4042 17.6187 12.0165 17.6187ZM43.6394 41.4536H36.1961V31.2526C36.1961 28.8201 36.14 25.6912 32.3287 25.6912C28.4501 25.6912 27.856 28.3395 27.856 31.0761V41.4536H20.4127V20.4828H27.5533V23.3469H27.6542C28.6519 21.6991 31.0844 19.9629 34.7052 19.9629C42.2382 19.9629 43.6394 24.3082 43.6394 29.9579V41.4536Z"
                    fill="black"
                  ></path>
                </g>
                <defs>
                  <clipPath id="clip_0_5_39">
                    <rect
                      width="50.22"
                      height="50.22"
                      fill="white"
                      transform="translate(0.560059 0.649902)"
                    ></rect>
                  </clipPath>
                </defs>
              </svg>
            </a>
          </div>
        </div>
        <div id="C_M">
          <img
            src="http://cdn.onlinewebfonts.com/svg/img_550782.png"
            alt="not available"
          />
          <div className="C_M_E">
            <p>Person Name</p>
            <br />
            <a href="#" target="_blank" rel="noopener noreferrer">
              <svg
                width="50"
                height="51"
                viewbox="0 0 51 51"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip_0_5_39)">
                  <path
                    d="M47.1929 3.78857H4.13599C2.16306 3.78857 0.560059 5.21082 0.560059 6.95675V44.5629C0.560059 46.3088 2.16306 47.7311 4.13599 47.7311H47.1929C49.1658 47.7311 50.7801 46.3088 50.7801 44.5629V6.95675C50.7801 5.21082 49.1658 3.78857 47.1929 3.78857ZM15.7382 41.4536H8.29484V20.4828H15.7494V41.4536H15.7382ZM12.0165 17.6187C9.6288 17.6187 7.70072 15.9218 7.70072 13.8424C7.70072 11.763 9.6288 10.0661 12.0165 10.0661C14.393 10.0661 16.3323 11.763 16.3323 13.8424C16.3323 15.9316 14.4042 17.6187 12.0165 17.6187ZM43.6394 41.4536H36.1961V31.2526C36.1961 28.8201 36.14 25.6912 32.3287 25.6912C28.4501 25.6912 27.856 28.3395 27.856 31.0761V41.4536H20.4127V20.4828H27.5533V23.3469H27.6542C28.6519 21.6991 31.0844 19.9629 34.7052 19.9629C42.2382 19.9629 43.6394 24.3082 43.6394 29.9579V41.4536Z"
                    fill="black"
                  ></path>
                </g>
                <defs>
                  <clipPath id="clip_0_5_39">
                    <rect
                      width="50.22"
                      height="50.22"
                      fill="white"
                      transform="translate(0.560059 0.649902)"
                    ></rect>
                  </clipPath>
                </defs>
              </svg>
            </a>
          </div>
        </div>
        <div id="C_M">
          <img
            src="http://cdn.onlinewebfonts.com/svg/img_550782.png"
            alt="not available"
          />
          <div className="C_M_E">
            <p>Person Name</p>
            <br />
            <a href="#" target="_blank" rel="noopener noreferrer">
              <svg
                width="50"
                height="51"
                viewbox="0 0 51 51"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip_0_5_39)">
                  <path
                    d="M47.1929 3.78857H4.13599C2.16306 3.78857 0.560059 5.21082 0.560059 6.95675V44.5629C0.560059 46.3088 2.16306 47.7311 4.13599 47.7311H47.1929C49.1658 47.7311 50.7801 46.3088 50.7801 44.5629V6.95675C50.7801 5.21082 49.1658 3.78857 47.1929 3.78857ZM15.7382 41.4536H8.29484V20.4828H15.7494V41.4536H15.7382ZM12.0165 17.6187C9.6288 17.6187 7.70072 15.9218 7.70072 13.8424C7.70072 11.763 9.6288 10.0661 12.0165 10.0661C14.393 10.0661 16.3323 11.763 16.3323 13.8424C16.3323 15.9316 14.4042 17.6187 12.0165 17.6187ZM43.6394 41.4536H36.1961V31.2526C36.1961 28.8201 36.14 25.6912 32.3287 25.6912C28.4501 25.6912 27.856 28.3395 27.856 31.0761V41.4536H20.4127V20.4828H27.5533V23.3469H27.6542C28.6519 21.6991 31.0844 19.9629 34.7052 19.9629C42.2382 19.9629 43.6394 24.3082 43.6394 29.9579V41.4536Z"
                    fill="black"
                  ></path>
                </g>
                <defs>
                  <clipPath id="clip_0_5_39">
                    <rect
                      width="50.22"
                      height="50.22"
                      fill="white"
                      transform="translate(0.560059 0.649902)"
                    ></rect>
                  </clipPath>
                </defs>
              </svg>
            </a>
          </div>
        </div>
        <div id="C_M">
          <img
            src="http://cdn.onlinewebfonts.com/svg/img_550782.png"
            alt="not available"
          />
          <div className="C_M_E">
            <p>Person Name</p>
            <br />
            <a href="#" target="_blank" rel="noopener noreferrer">
              <svg
                width="50"
                height="51"
                viewbox="0 0 51 51"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip_0_5_39)">
                  <path
                    d="M47.1929 3.78857H4.13599C2.16306 3.78857 0.560059 5.21082 0.560059 6.95675V44.5629C0.560059 46.3088 2.16306 47.7311 4.13599 47.7311H47.1929C49.1658 47.7311 50.7801 46.3088 50.7801 44.5629V6.95675C50.7801 5.21082 49.1658 3.78857 47.1929 3.78857ZM15.7382 41.4536H8.29484V20.4828H15.7494V41.4536H15.7382ZM12.0165 17.6187C9.6288 17.6187 7.70072 15.9218 7.70072 13.8424C7.70072 11.763 9.6288 10.0661 12.0165 10.0661C14.393 10.0661 16.3323 11.763 16.3323 13.8424C16.3323 15.9316 14.4042 17.6187 12.0165 17.6187ZM43.6394 41.4536H36.1961V31.2526C36.1961 28.8201 36.14 25.6912 32.3287 25.6912C28.4501 25.6912 27.856 28.3395 27.856 31.0761V41.4536H20.4127V20.4828H27.5533V23.3469H27.6542C28.6519 21.6991 31.0844 19.9629 34.7052 19.9629C42.2382 19.9629 43.6394 24.3082 43.6394 29.9579V41.4536Z"
                    fill="black"
                  ></path>
                </g>
                <defs>
                  <clipPath id="clip_0_5_39">
                    <rect
                      width="50.22"
                      height="50.22"
                      fill="white"
                      transform="translate(0.560059 0.649902)"
                    ></rect>
                  </clipPath>
                </defs>
              </svg>
            </a>
          </div>
        </div>
        <div id="C_M">
          <img
            src="http://cdn.onlinewebfonts.com/svg/img_550782.png"
            alt="not available"
          />
          <div className="C_M_E">
            <p>Person Name</p>
            <br />
            <a href="#" target="_blank" rel="noopener noreferrer">
              <svg
                width="50"
                height="51"
                viewbox="0 0 51 51"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip_0_5_39)">
                  <path
                    d="M47.1929 3.78857H4.13599C2.16306 3.78857 0.560059 5.21082 0.560059 6.95675V44.5629C0.560059 46.3088 2.16306 47.7311 4.13599 47.7311H47.1929C49.1658 47.7311 50.7801 46.3088 50.7801 44.5629V6.95675C50.7801 5.21082 49.1658 3.78857 47.1929 3.78857ZM15.7382 41.4536H8.29484V20.4828H15.7494V41.4536H15.7382ZM12.0165 17.6187C9.6288 17.6187 7.70072 15.9218 7.70072 13.8424C7.70072 11.763 9.6288 10.0661 12.0165 10.0661C14.393 10.0661 16.3323 11.763 16.3323 13.8424C16.3323 15.9316 14.4042 17.6187 12.0165 17.6187ZM43.6394 41.4536H36.1961V31.2526C36.1961 28.8201 36.14 25.6912 32.3287 25.6912C28.4501 25.6912 27.856 28.3395 27.856 31.0761V41.4536H20.4127V20.4828H27.5533V23.3469H27.6542C28.6519 21.6991 31.0844 19.9629 34.7052 19.9629C42.2382 19.9629 43.6394 24.3082 43.6394 29.9579V41.4536Z"
                    fill="black"
                  ></path>
                </g>
                <defs>
                  <clipPath id="clip_0_5_39">
                    <rect
                      width="50.22"
                      height="50.22"
                      fill="white"
                      transform="translate(0.560059 0.649902)"
                    ></rect>
                  </clipPath>
                </defs>
              </svg>
            </a>
          </div>
        </div>
        <div id="C_M">
          <img
            src="http://cdn.onlinewebfonts.com/svg/img_550782.png"
            alt="not available"
          />
          <div className="C_M_E">
            <p>Person Name</p>
            <br />
            <a href="#" target="_blank" rel="noopener noreferrer">
              <svg
                width="50"
                height="51"
                viewbox="0 0 51 51"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip_0_5_39)">
                  <path
                    d="M47.1929 3.78857H4.13599C2.16306 3.78857 0.560059 5.21082 0.560059 6.95675V44.5629C0.560059 46.3088 2.16306 47.7311 4.13599 47.7311H47.1929C49.1658 47.7311 50.7801 46.3088 50.7801 44.5629V6.95675C50.7801 5.21082 49.1658 3.78857 47.1929 3.78857ZM15.7382 41.4536H8.29484V20.4828H15.7494V41.4536H15.7382ZM12.0165 17.6187C9.6288 17.6187 7.70072 15.9218 7.70072 13.8424C7.70072 11.763 9.6288 10.0661 12.0165 10.0661C14.393 10.0661 16.3323 11.763 16.3323 13.8424C16.3323 15.9316 14.4042 17.6187 12.0165 17.6187ZM43.6394 41.4536H36.1961V31.2526C36.1961 28.8201 36.14 25.6912 32.3287 25.6912C28.4501 25.6912 27.856 28.3395 27.856 31.0761V41.4536H20.4127V20.4828H27.5533V23.3469H27.6542C28.6519 21.6991 31.0844 19.9629 34.7052 19.9629C42.2382 19.9629 43.6394 24.3082 43.6394 29.9579V41.4536Z"
                    fill="black"
                  ></path>
                </g>
                <defs>
                  <clipPath id="clip_0_5_39">
                    <rect
                      width="50.22"
                      height="50.22"
                      fill="white"
                      transform="translate(0.560059 0.649902)"
                    ></rect>
                  </clipPath>
                </defs>
              </svg>
            </a>
          </div>
        </div>
        <div id="C_M">
          <img
            src="http://cdn.onlinewebfonts.com/svg/img_550782.png"
            alt="not available"
          />
          <div className="C_M_E">
            <p>Person Name</p>
            <br />
            <a href="#" target="_blank" rel="noopener noreferrer">
              <svg
                width="50"
                height="51"
                viewbox="0 0 51 51"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip_0_5_39)">
                  <path
                    d="M47.1929 3.78857H4.13599C2.16306 3.78857 0.560059 5.21082 0.560059 6.95675V44.5629C0.560059 46.3088 2.16306 47.7311 4.13599 47.7311H47.1929C49.1658 47.7311 50.7801 46.3088 50.7801 44.5629V6.95675C50.7801 5.21082 49.1658 3.78857 47.1929 3.78857ZM15.7382 41.4536H8.29484V20.4828H15.7494V41.4536H15.7382ZM12.0165 17.6187C9.6288 17.6187 7.70072 15.9218 7.70072 13.8424C7.70072 11.763 9.6288 10.0661 12.0165 10.0661C14.393 10.0661 16.3323 11.763 16.3323 13.8424C16.3323 15.9316 14.4042 17.6187 12.0165 17.6187ZM43.6394 41.4536H36.1961V31.2526C36.1961 28.8201 36.14 25.6912 32.3287 25.6912C28.4501 25.6912 27.856 28.3395 27.856 31.0761V41.4536H20.4127V20.4828H27.5533V23.3469H27.6542C28.6519 21.6991 31.0844 19.9629 34.7052 19.9629C42.2382 19.9629 43.6394 24.3082 43.6394 29.9579V41.4536Z"
                    fill="black"
                  ></path>
                </g>
                <defs>
                  <clipPath id="clip_0_5_39">
                    <rect
                      width="50.22"
                      height="50.22"
                      fill="white"
                      transform="translate(0.560059 0.649902)"
                    ></rect>
                  </clipPath>
                </defs>
              </svg>
            </a>
          </div>
        </div>
        <div id="C_M">
          <img
            src="http://cdn.onlinewebfonts.com/svg/img_550782.png"
            alt="not available"
          />
          <div className="C_M_E">
            <p>Person Name</p>
            <br />
            <a href="#" target="_blank" rel="noopener noreferrer">
              <svg
                width="50"
                height="51"
                viewbox="0 0 51 51"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip_0_5_39)">
                  <path
                    d="M47.1929 3.78857H4.13599C2.16306 3.78857 0.560059 5.21082 0.560059 6.95675V44.5629C0.560059 46.3088 2.16306 47.7311 4.13599 47.7311H47.1929C49.1658 47.7311 50.7801 46.3088 50.7801 44.5629V6.95675C50.7801 5.21082 49.1658 3.78857 47.1929 3.78857ZM15.7382 41.4536H8.29484V20.4828H15.7494V41.4536H15.7382ZM12.0165 17.6187C9.6288 17.6187 7.70072 15.9218 7.70072 13.8424C7.70072 11.763 9.6288 10.0661 12.0165 10.0661C14.393 10.0661 16.3323 11.763 16.3323 13.8424C16.3323 15.9316 14.4042 17.6187 12.0165 17.6187ZM43.6394 41.4536H36.1961V31.2526C36.1961 28.8201 36.14 25.6912 32.3287 25.6912C28.4501 25.6912 27.856 28.3395 27.856 31.0761V41.4536H20.4127V20.4828H27.5533V23.3469H27.6542C28.6519 21.6991 31.0844 19.9629 34.7052 19.9629C42.2382 19.9629 43.6394 24.3082 43.6394 29.9579V41.4536Z"
                    fill="black"
                  ></path>
                </g>
                <defs>
                  <clipPath id="clip_0_5_39">
                    <rect
                      width="50.22"
                      height="50.22"
                      fill="white"
                      transform="translate(0.560059 0.649902)"
                    ></rect>
                  </clipPath>
                </defs>
              </svg>
            </a>
          </div>
        </div>
        <div id="C_M">
          <img
            src="http://cdn.onlinewebfonts.com/svg/img_550782.png"
            alt="not available"
          />
          <div className="C_M_E">
            <p>Person Name</p>
            <br />
            <a href="#" target="_blank" rel="noopener noreferrer">
              <svg
                width="50"
                height="51"
                viewbox="0 0 51 51"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip_0_5_39)">
                  <path
                    d="M47.1929 3.78857H4.13599C2.16306 3.78857 0.560059 5.21082 0.560059 6.95675V44.5629C0.560059 46.3088 2.16306 47.7311 4.13599 47.7311H47.1929C49.1658 47.7311 50.7801 46.3088 50.7801 44.5629V6.95675C50.7801 5.21082 49.1658 3.78857 47.1929 3.78857ZM15.7382 41.4536H8.29484V20.4828H15.7494V41.4536H15.7382ZM12.0165 17.6187C9.6288 17.6187 7.70072 15.9218 7.70072 13.8424C7.70072 11.763 9.6288 10.0661 12.0165 10.0661C14.393 10.0661 16.3323 11.763 16.3323 13.8424C16.3323 15.9316 14.4042 17.6187 12.0165 17.6187ZM43.6394 41.4536H36.1961V31.2526C36.1961 28.8201 36.14 25.6912 32.3287 25.6912C28.4501 25.6912 27.856 28.3395 27.856 31.0761V41.4536H20.4127V20.4828H27.5533V23.3469H27.6542C28.6519 21.6991 31.0844 19.9629 34.7052 19.9629C42.2382 19.9629 43.6394 24.3082 43.6394 29.9579V41.4536Z"
                    fill="black"
                  ></path>
                </g>
                <defs>
                  <clipPath id="clip_0_5_39">
                    <rect
                      width="50.22"
                      height="50.22"
                      fill="white"
                      transform="translate(0.560059 0.649902)"
                    ></rect>
                  </clipPath>
                </defs>
              </svg>
            </a>
          </div>
        </div>
        <div id="C_M">
          <img
            src="http://cdn.onlinewebfonts.com/svg/img_550782.png"
            alt="not available"
          />
          <div className="C_M_E">
            <p>Person Name</p>
            <br />
            <a href="#" target="_blank" rel="noopener noreferrer">
              <svg
                width="50"
                height="51"
                viewbox="0 0 51 51"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip_0_5_39)">
                  <path
                    d="M47.1929 3.78857H4.13599C2.16306 3.78857 0.560059 5.21082 0.560059 6.95675V44.5629C0.560059 46.3088 2.16306 47.7311 4.13599 47.7311H47.1929C49.1658 47.7311 50.7801 46.3088 50.7801 44.5629V6.95675C50.7801 5.21082 49.1658 3.78857 47.1929 3.78857ZM15.7382 41.4536H8.29484V20.4828H15.7494V41.4536H15.7382ZM12.0165 17.6187C9.6288 17.6187 7.70072 15.9218 7.70072 13.8424C7.70072 11.763 9.6288 10.0661 12.0165 10.0661C14.393 10.0661 16.3323 11.763 16.3323 13.8424C16.3323 15.9316 14.4042 17.6187 12.0165 17.6187ZM43.6394 41.4536H36.1961V31.2526C36.1961 28.8201 36.14 25.6912 32.3287 25.6912C28.4501 25.6912 27.856 28.3395 27.856 31.0761V41.4536H20.4127V20.4828H27.5533V23.3469H27.6542C28.6519 21.6991 31.0844 19.9629 34.7052 19.9629C42.2382 19.9629 43.6394 24.3082 43.6394 29.9579V41.4536Z"
                    fill="black"
                  ></path>
                </g>
                <defs>
                  <clipPath id="clip_0_5_39">
                    <rect
                      width="50.22"
                      height="50.22"
                      fill="white"
                      transform="translate(0.560059 0.649902)"
                    ></rect>
                  </clipPath>
                </defs>
              </svg>
            </a>
          </div>
        </div>
        <div id="C_M">
          <img
            src="http://cdn.onlinewebfonts.com/svg/img_550782.png"
            alt="not available"
          />
          <div className="C_M_E">
            <p>Person Name</p>
            <br />
            <a href="#" target="_blank" rel="noopener noreferrer">
              <svg
                width="50"
                height="51"
                viewbox="0 0 51 51"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip_0_5_39)">
                  <path
                    d="M47.1929 3.78857H4.13599C2.16306 3.78857 0.560059 5.21082 0.560059 6.95675V44.5629C0.560059 46.3088 2.16306 47.7311 4.13599 47.7311H47.1929C49.1658 47.7311 50.7801 46.3088 50.7801 44.5629V6.95675C50.7801 5.21082 49.1658 3.78857 47.1929 3.78857ZM15.7382 41.4536H8.29484V20.4828H15.7494V41.4536H15.7382ZM12.0165 17.6187C9.6288 17.6187 7.70072 15.9218 7.70072 13.8424C7.70072 11.763 9.6288 10.0661 12.0165 10.0661C14.393 10.0661 16.3323 11.763 16.3323 13.8424C16.3323 15.9316 14.4042 17.6187 12.0165 17.6187ZM43.6394 41.4536H36.1961V31.2526C36.1961 28.8201 36.14 25.6912 32.3287 25.6912C28.4501 25.6912 27.856 28.3395 27.856 31.0761V41.4536H20.4127V20.4828H27.5533V23.3469H27.6542C28.6519 21.6991 31.0844 19.9629 34.7052 19.9629C42.2382 19.9629 43.6394 24.3082 43.6394 29.9579V41.4536Z"
                    fill="black"
                  ></path>
                </g>
                <defs>
                  <clipPath id="clip_0_5_39">
                    <rect
                      width="50.22"
                      height="50.22"
                      fill="white"
                      transform="translate(0.560059 0.649902)"
                    ></rect>
                  </clipPath>
                </defs>
              </svg>
            </a>
          </div>
        </div>
        <div id="C_M">
          <img
            src="http://cdn.onlinewebfonts.com/svg/img_550782.png"
            alt="not available"
          />
          <div className="C_M_E">
            <p>Person Name</p>
            <br />
            <a href="#" target="_blank" rel="noopener noreferrer">
              <svg
                width="50"
                height="51"
                viewbox="0 0 51 51"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip_0_5_39)">
                  <path
                    d="M47.1929 3.78857H4.13599C2.16306 3.78857 0.560059 5.21082 0.560059 6.95675V44.5629C0.560059 46.3088 2.16306 47.7311 4.13599 47.7311H47.1929C49.1658 47.7311 50.7801 46.3088 50.7801 44.5629V6.95675C50.7801 5.21082 49.1658 3.78857 47.1929 3.78857ZM15.7382 41.4536H8.29484V20.4828H15.7494V41.4536H15.7382ZM12.0165 17.6187C9.6288 17.6187 7.70072 15.9218 7.70072 13.8424C7.70072 11.763 9.6288 10.0661 12.0165 10.0661C14.393 10.0661 16.3323 11.763 16.3323 13.8424C16.3323 15.9316 14.4042 17.6187 12.0165 17.6187ZM43.6394 41.4536H36.1961V31.2526C36.1961 28.8201 36.14 25.6912 32.3287 25.6912C28.4501 25.6912 27.856 28.3395 27.856 31.0761V41.4536H20.4127V20.4828H27.5533V23.3469H27.6542C28.6519 21.6991 31.0844 19.9629 34.7052 19.9629C42.2382 19.9629 43.6394 24.3082 43.6394 29.9579V41.4536Z"
                    fill="black"
                  ></path>
                </g>
                <defs>
                  <clipPath id="clip_0_5_39">
                    <rect
                      width="50.22"
                      height="50.22"
                      fill="white"
                      transform="translate(0.560059 0.649902)"
                    ></rect>
                  </clipPath>
                </defs>
              </svg>
            </a>
          </div>
        </div>
        <div id="C_M">
          <img
            src="http://cdn.onlinewebfonts.com/svg/img_550782.png"
            alt="not available"
          />
          <div className="C_M_E">
            <p>Person Name</p>
            <br />
            <a href="#" target="_blank" rel="noopener noreferrer">
              <svg
                width="50"
                height="51"
                viewbox="0 0 51 51"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip_0_5_39)">
                  <path
                    d="M47.1929 3.78857H4.13599C2.16306 3.78857 0.560059 5.21082 0.560059 6.95675V44.5629C0.560059 46.3088 2.16306 47.7311 4.13599 47.7311H47.1929C49.1658 47.7311 50.7801 46.3088 50.7801 44.5629V6.95675C50.7801 5.21082 49.1658 3.78857 47.1929 3.78857ZM15.7382 41.4536H8.29484V20.4828H15.7494V41.4536H15.7382ZM12.0165 17.6187C9.6288 17.6187 7.70072 15.9218 7.70072 13.8424C7.70072 11.763 9.6288 10.0661 12.0165 10.0661C14.393 10.0661 16.3323 11.763 16.3323 13.8424C16.3323 15.9316 14.4042 17.6187 12.0165 17.6187ZM43.6394 41.4536H36.1961V31.2526C36.1961 28.8201 36.14 25.6912 32.3287 25.6912C28.4501 25.6912 27.856 28.3395 27.856 31.0761V41.4536H20.4127V20.4828H27.5533V23.3469H27.6542C28.6519 21.6991 31.0844 19.9629 34.7052 19.9629C42.2382 19.9629 43.6394 24.3082 43.6394 29.9579V41.4536Z"
                    fill="black"
                  ></path>
                </g>
                <defs>
                  <clipPath id="clip_0_5_39">
                    <rect
                      width="50.22"
                      height="50.22"
                      fill="white"
                      transform="translate(0.560059 0.649902)"
                    ></rect>
                  </clipPath>
                </defs>
              </svg>
            </a>
          </div>
        </div>
        <div id="C_M">
          <img
            src="http://cdn.onlinewebfonts.com/svg/img_550782.png"
            alt="not available"
          />
          <div className="C_M_E">
            <p>Person Name</p>
            <br />
            <a href="#" target="_blank" rel="noopener noreferrer">
              <svg
                width="50"
                height="51"
                viewbox="0 0 51 51"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip_0_5_39)">
                  <path
                    d="M47.1929 3.78857H4.13599C2.16306 3.78857 0.560059 5.21082 0.560059 6.95675V44.5629C0.560059 46.3088 2.16306 47.7311 4.13599 47.7311H47.1929C49.1658 47.7311 50.7801 46.3088 50.7801 44.5629V6.95675C50.7801 5.21082 49.1658 3.78857 47.1929 3.78857ZM15.7382 41.4536H8.29484V20.4828H15.7494V41.4536H15.7382ZM12.0165 17.6187C9.6288 17.6187 7.70072 15.9218 7.70072 13.8424C7.70072 11.763 9.6288 10.0661 12.0165 10.0661C14.393 10.0661 16.3323 11.763 16.3323 13.8424C16.3323 15.9316 14.4042 17.6187 12.0165 17.6187ZM43.6394 41.4536H36.1961V31.2526C36.1961 28.8201 36.14 25.6912 32.3287 25.6912C28.4501 25.6912 27.856 28.3395 27.856 31.0761V41.4536H20.4127V20.4828H27.5533V23.3469H27.6542C28.6519 21.6991 31.0844 19.9629 34.7052 19.9629C42.2382 19.9629 43.6394 24.3082 43.6394 29.9579V41.4536Z"
                    fill="black"
                  ></path>
                </g>
                <defs>
                  <clipPath id="clip_0_5_39">
                    <rect
                      width="50.22"
                      height="50.22"
                      fill="white"
                      transform="translate(0.560059 0.649902)"
                    ></rect>
                  </clipPath>
                </defs>
              </svg>
            </a>
          </div>
        </div>
        <div id="C_M">
          <img
            src="http://cdn.onlinewebfonts.com/svg/img_550782.png"
            alt="not available"
          />
          <div className="C_M_E">
            <p>Person Name</p>
            <br />
            <a href="#" target="_blank" rel="noopener noreferrer">
              <svg
                width="50"
                height="51"
                viewbox="0 0 51 51"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip_0_5_39)">
                  <path
                    d="M47.1929 3.78857H4.13599C2.16306 3.78857 0.560059 5.21082 0.560059 6.95675V44.5629C0.560059 46.3088 2.16306 47.7311 4.13599 47.7311H47.1929C49.1658 47.7311 50.7801 46.3088 50.7801 44.5629V6.95675C50.7801 5.21082 49.1658 3.78857 47.1929 3.78857ZM15.7382 41.4536H8.29484V20.4828H15.7494V41.4536H15.7382ZM12.0165 17.6187C9.6288 17.6187 7.70072 15.9218 7.70072 13.8424C7.70072 11.763 9.6288 10.0661 12.0165 10.0661C14.393 10.0661 16.3323 11.763 16.3323 13.8424C16.3323 15.9316 14.4042 17.6187 12.0165 17.6187ZM43.6394 41.4536H36.1961V31.2526C36.1961 28.8201 36.14 25.6912 32.3287 25.6912C28.4501 25.6912 27.856 28.3395 27.856 31.0761V41.4536H20.4127V20.4828H27.5533V23.3469H27.6542C28.6519 21.6991 31.0844 19.9629 34.7052 19.9629C42.2382 19.9629 43.6394 24.3082 43.6394 29.9579V41.4536Z"
                    fill="black"
                  ></path>
                </g>
                <defs>
                  <clipPath id="clip_0_5_39">
                    <rect
                      width="50.22"
                      height="50.22"
                      fill="white"
                      transform="translate(0.560059 0.649902)"
                    ></rect>
                  </clipPath>
                </defs>
              </svg>
            </a>
          </div>
        </div>
      </div>
    </>
  );
}

export default Contributors;
